/* globals EDUCTS_DEFINED_CONFIG */
/* eslint-disable no-var,object-shorthand,prefer-object-spread,prefer-template */
// This file is used in browsers without getting babeled. Ensure that you do not use Features our
// supported browsers do not support
var objectPath = require('object-path')

var EDUCTS_CONFIG = null

if (typeof EDUCTS_DEFINED_CONFIG === 'string') {
  EDUCTS_CONFIG = JSON.parse(EDUCTS_DEFINED_CONFIG)
}

if (EDUCTS_CONFIG === null) {
  throw new Error(
    'Could not read config. Please ensure that you are using Educts CLI to build your sources.'
  )
}

module.exports = {
  __esModule: true,
  read: function() {
    throw new Error('Read config is only usable in server side code')
  },
  validate: function() {
    throw new Error('Validate config is only usable in server side code')
  },
  parse: function() {
    throw new Error('Parse config is only usable in server side code')
  },
  filter: function() {
    throw new Error('Filter config is only usable in server side code')
  },
  default: {
    get: function(key, defaultValue) {
      if (!objectPath.has(EDUCTS_CONFIG, key) && !defaultValue) {
        throw new Error('Accessing non existing error key: ' + key)
      }

      return objectPath.get(EDUCTS_CONFIG, key, defaultValue)
    },
    has: function(key) {
      return objectPath.has(EDUCTS_CONFIG, key)
    },
  },
}
